import { render, staticRenderFns } from "./FootballTeamCard.vue?vue&type=template&id=437a09cc&scoped=true"
import script from "./FootballTeamCard.vue?vue&type=script&lang=js"
export * from "./FootballTeamCard.vue?vue&type=script&lang=js"
import style0 from "./FootballTeamCard.vue?vue&type=style&index=0&id=437a09cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437a09cc",
  null
  
)

export default component.exports